var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:32:25
 * @modify date 2021-09-09 09:32:25
 * @desc [公共无状态数据]
 */
import dayjs from 'dayjs';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../libraries';
let CurrencyController = class CurrencyController {
    constructor() {
        this.codeTable = [];
        this.subtypeTypeList = [];
        this.rolesList = [];
    }
    /**
     * @desc SN 上报动态时间
     */
    get isSN() {
        const diff = dayjs().diff('2022-09-30', 'day');
        return diff < 1;
    }
    /** 图片验证码 */
    getImgCode() {
        return AjaxBasics.request(EnumAPI.bffsvr_imgCode);
    }
    /** 发送短信验证码 */
    sendCode(queryParams) {
        return AjaxBasics.request({
            ...EnumAPI.bffsvr_SendCode,
            body: queryParams,
            queryParams,
            headers: lodash.pick(queryParams, 'imgSession'),
        });
    }
    /** 上传图片 */
    uploadimg(file) {
        const body = new FormData();
        body.append('file', file);
        // return AjaxBasics.request({ ...EnumAPI.comsvr_upload_img, body });
    }
    /**
     * 获取 省
     * @returns
     */
    getProvinces() {
        return AjaxBasics.requestEnum(EnumAPI.usersvr_get_provinces, {
            labelKey: 'name',
            valueKey: 'citycode',
        });
    }
    /**
     * 获取 市
     * @returns
     */
    getCities(provideCode) {
        return AjaxBasics.requestEnum({ ...EnumAPI.usersvr_get_citys, body: { provideCode } }, { labelKey: 'name', valueKey: 'citycode' });
    }
    /**
     * 获取 区
     * @returns
     */
    getDistrict(cityCode) {
        return AjaxBasics.requestEnum({ ...EnumAPI.usersvr_get_district, body: { cityCode } }, { labelKey: 'name', valueKey: 'citycode' });
    }
    // /**
    //  * 获取 指引状态
    //  * @returns
    //  */
    // async getGuide() {
    //   const res = await AjaxBasics.request(EnumAPI.bffsvr_guide_get);
    //   const status = lodash.get(res, 'status', false);
    //   if (status) {
    //     this.setGuide(0);
    //   }
    //   return status;
    // }
    // /**
    //  * 设置 指引状态
    //  * @returns
    //  */
    // setGuide(status: 0 | 1) {
    //   return AjaxBasics.request({
    //     ...EnumAPI.bffsvr_guide_set,
    //     body: { status },
    //   });
    // }
    /** 获取k码的list */
    async getResellerByTax() {
        const res = await AjaxBasics.request(EnumAPI.bffsvr_getResellerByTax);
        return lodash.map(res, (item) => {
            return {
                label: item,
                value: item,
            };
        });
    }
    /**
     * 获取授权牌信息
     * @return {*}
     * @memberof CurrencyController
     */
    getLicense() {
        // return AjaxBasics.request<any>(EnumAPI.content_license_user_token);
    }
    /**
     * 报错授权牌信息
     * @param {*} body
     * @return {*}
     * @memberof CurrencyController
     */
    saveLicense(body) {
        // return AjaxBasics.request({ ...EnumAPI.content_license_record_save, body });
    }
    // 获取码表
    getFieldName(field, value) {
        return (lodash.find(lodash.filter(this.codeTable, ['dicType', field]), [
            'itemId',
            value,
        ])?.itemName || '');
    }
    // 渠道类型子类型
    getReseller(value) {
        if (lodash.isEmpty(value)) {
            return '';
        }
        let arr = lodash.map(value, this.resellerTypeJoint);
        return lodash.toString(arr).replace(/\,/g, '；');
    }
    resellerTypeJoint(item) {
        let subList = lodash.find(this.subtypeTypeList, ['resellerTypeId', item.typeId])
            ?.subTypeInfos || [];
        return `${lodash.find(this.subtypeTypeList, ['resellerTypeId', item.typeId])
            ?.resellerTypeName || ''}—${lodash.find(subList, ['resellerSubTypeId', item.subtypeId])
            ?.resellerSubTypeName || ''}`;
    }
    // 角色
    getRoleName(value) {
        if (!value)
            return;
        const splitRole = value.split(',');
        let arr = lodash.map(splitRole, (item) => {
            return (lodash.find(this.rolesList, ['id', Number(item)])?.roleName || '--');
        });
        return lodash.toString(arr);
    }
};
CurrencyController = __decorate([
    BindAll()
], CurrencyController);
export { CurrencyController };
